import pb from '../lib/pocketbase';

export async function getCobradores(page, perPage) {
  return await pb.collection('cobrador').getList(page, perPage, {
    sort: '-created', // Ordenar por fecha de creación descendente
    $autoCancel: false,
    expand: '' // Ajusta si necesitas expandir relaciones
  });
}

export async function createCobrador(cobrador) {
  return await pb.collection('cobrador').create(cobrador);
}

export async function updateCobrador(id, cobrador) {
  return await pb.collection('cobrador').update(id, cobrador);
}

export async function deleteCobrador(id) {
  return await pb.collection('cobrador').delete(id);
}